<template>
	<!-- 弹出向导层 start-->
	<div id="pop-tan" class="pop-tan" v-show="pop_show">
		<div class="pop-tan-bg" @click="closeshow()"></div>

		<div id="pop_body" class="pop-tan-content" v-loading="element_loading" element-loading-text="拼命加载中......"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
			<!-- 动态查询区生成 -->
			<div class="pop-tan_children">
				<div class="pop-tan-head-close">
					<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
				</div>
				<div class="pop-tan-head-body">
					<div style=" display: flex;align-items: center;">
						<h5>{{title}}</h5>&nbsp;&nbsp;<h5 class="red">{{sel_from}}</h5>&nbsp;&nbsp;<h5>{{sheet_flag}}
						</h5>&nbsp;&nbsp;
						<h1 class="red"  v-show="sel_from=='明细'">一条明细只能有一个附件</h1>
					</div>
					<div class="content_edit">
						<div class="content_edit_item">
							<button class="pre_btn_ok" @click="refresh_data()">
								刷新
							</button>&nbsp;
							<button class="pre_btn_ok" @click="fun_upd_mode()" v-show="fileup=='1'">
								修改|保存
							</button>&nbsp;
							<button class="pre_btn_ok" @click="pre_sel_file()" v-show="fileup=='1'">
								选择文件
							</button>&nbsp;
							<button class="pre_btn_ok" @click="pre_look_file()" v-show="filelook=='1'">
								预览文件
							</button>&nbsp;
							<button class="pre_btn_ok btn_del" @click="pre_del_file()" v-show="filedel=='1'">
								删除文件
							</button>&nbsp;
							<button class="pre_btn_ok" @click="pre_up_file()" v-show="fileup=='1'">
								上传文件
							</button>
						</div>
					</div>

					<div class="content_edit">
						<div class="content_edit_item">
							<label>业务单号:{{sheet_no}}</label>&nbsp;&nbsp;
							<label>说明:</label><input type="text" class="f-mode" v-model="mode_name"
								placeholder="选填附件类型说明" />&nbsp;&nbsp;
							<span>文件名称:{{file_name}}&nbsp;&nbsp;{{file_up}}</span>
						</div>
					</div>
					<div class="content_edit content-row">
						<div>

							<table class="dataintable" border="1" cellpadding="2" cellspacing="1">

								<tr>
									<th>序号</th>
									<th class="short0">标识</th>
									<th class="short2">划分</th>
									<th class="short0">名称</th>
									<th class="short2">大小</th>
									<th class="short0">图片</th>
									<th class="short2">类型</th>
									<th class="short2">上传人</th>
									<th class="long1">更新时间</th>
									<!-- <th>操作</th> -->
								</tr>

								<tr :id="'f'+item.row_num" v-for="(item, index) in list_file" :key="index"
									@click="sel_row(item)">
									<td>{{ item.row_num }}</td>
									<td class="short0">{{ item.sheet_no }}</td>
									<td class="short2">{{ item.m_name }}</td>
									<td class="short0">{{ item.f_name }}</td>
									<td class="short2">{{ item.f_size }}</td>
									<td class="short0 cen">

										<el-image v-show="item.f_url!=''" style="width: 20px; height: 20px"
											:src="check_url(item.f_url)" :preview-src-list="[check_url(item.f_url)]">
										</el-image>

										<el-image v-show="item.f_url==''">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</td>
									<td class="short2">{{ item.f_type }}</td>
									<td class="short2">{{ item.u_name }}</td>
									<td class="long1">{{ item.sys_date }}</td>
									<!-- <td>
										<button @click="fun_del_file(item)">删除</button>
									</td> -->
								</tr>

							</table>


						</div>
						<div id="fileDataArea" class="file-right" contenteditable="true"
							@paste.stop.prevent="fun_paste($event)">
							<!-- iconfont icon-increase  -->
							<div class="file-up " v-show="show_one">
								<el-image v-show="file_url!='' && show_lookimg"
									style="width: 100%;height: auto;max-width:200px;max-height: 320px;"
									:src="check_url(file_url)">
								</el-image>

								<el-image v-show="file_url=='' && show_lookimg">
									<div slot="error" class="image-slot">
										<i class="el-icon-picture-outline"></i>
									</div>
								</el-image>
								<span class="file-other" v-show="!show_lookimg">{{file_type}}文件</span>
							</div>
							<div class="file-txt" v-show="show_one">
								<div>
									截屏或复制的文件请黏贴到此处！
								</div>
							</div>
							<div class="f-body" v-show="!show_one">
								<div class="f-sel" v-for="(item,index) in list_sel" :key="index"
									@click="fun_sel_file(item)">
									<label class="f-title">{{item.file.name}}</label>
									&nbsp;&nbsp;
									<label class="f-class">{{item.mode_name}}</label>
									&nbsp;&nbsp;
									<button class="pre_btn_ok" @click="fun_file_more_one(item)">上传</button>
									&nbsp;&nbsp;
									<button class="pre_btn_ok btn_del" @click="fun_file_more_del(item)">删除</button>
								</div>
								<div class="f-bottom">
									<button class="pre_btn_ok" @click="fun_file_more_up">全部上传</button>
								</div>
							</div>

						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="savefile" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" :id="fileId" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

		<!-- 		<vue-viewer style="display: inline-block" :thumb="image" :full="image">
		</vue-viewer> -->

	</div>
</template>

<script>
	/*

要求 截屏上传和黏贴上传
*/
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_EasyUpdate
	} from '@/utils/loadhttpdata.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	import {
		JsonCheck
	} from '@/utils/method.js';

	export default {
		name: "pre_tan_filelist",
		data() {
			return {
				element_loading: false,
				fileId: 'prefile',
				pop_show: false,
				show_btn: true,
				row_id: '',
				sys_date: '',

				title: '',
				sheet_no: "",
				mode_type: '',
				mode_name: '',
				sheet_flag: "",
				sel_from: '',

				screenWidth: '',
				screenHeight: '',

				f_name: "",
				show_file: false,
				show_lookimg: true,

				//文件
				up_method: "select",
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "",
				file_type: '',
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',

				list_file: [],
				fileup: '0',
				filelook: '0',
				filedel: '0',

				list_sel: [],
				list_sel_id: 0,

				show_one: true

			};
		},
		mounted: function() {
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize
			// cut
			// paste
			// let f = document.getElementById('fileDataArea');
			// window.addEventListener('cut', function(e) {
			// 	if (!(e.clipboardData && e.clipboardData.items)) {
			// 		return;
			// 	}
			// 	that.fun_cut(e.clipboardData);
			// }, false);
			// // 这里只是操作dom
			// f.addEventListener('paste', function(e) {
			// 	if (!(e.clipboardData && e.clipboardData.items)) {
			// 		return;
			// 	}
			// 	that.fun_paste(e.clipboardData);
			// }, false);
			
		},
		created() {
			this.fileId = 'prefile' + new Date().getTime();
			// console.log(this.pre_item);
		},
		activated: function() {
			// console.log('keep-alive 组件激活时调用 hj-input激活');
			// this.fileId = 'prefile' + new Date().getTime();
		},
		// beforeUpdate(){
		//   this.$nextTick(() => { //在数据加载完，重新渲染表格
		//     this.$refs['table'].doLayout();
		//   })
		// },
		watch: {
			mode_name(val) {
				if (this.list_sel_id > 0) {
					for (let i = 0; i < this.list_sel.length; i++) {
						if (this.list_sel[i].id == this.list_sel_id) {
							this.list_sel[i].mode_name = val;
							break;
						}
					}
				}
			}

		},
		methods: {
			fun_paste: function(e) {
				if (this.fileup != '1') {
					this.$message({
						message: '没有权限上传附件!',
						type: 'warning'
					});
					return;
				}

				// 处理黏贴数据
				// console.log('获得剪切板的内容', e);
				const cbd = e.clipboardData;
				const ua = window.navigator.userAgent;

				// console.log(ua);
				// 如果是 Safari 直接 return
				if (!(e.clipboardData && e.clipboardData.items)) {
					return;
				}
				if (cbd.items && cbd.items.length === 2 && cbd.items[0].kind === "string" && cbd.items[1].kind ===
					"file" &&
					cbd.types && cbd.types.length === 2 && cbd.types[0] === "text/plain" && cbd.types[1] === "Files" &&
					ua.match(/Macintosh/i) && Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49) {
					return;
				}
				let that = this;

				// console.log('黏贴的内容数量', cbd.items.length);
				if(this.sel_from == '明细' && cbd.items.length>1){
					this.$message({
						message: '明细数据只可以上传一条附件!',
						type: 'warning'
					});
					return;
				}
				
				if(this.sel_from == '明细' && this.list_file.length>=1){
					this.$message({
						message: '明细数据只可以上传一条附件!',
						type: 'warning'
					});
					return;
				}
				
				this.list_sel = [];
				for (let i = 0; i < cbd.items.length; i++) {
					let item = cbd.items[i];
					if (i >= 9) {
						break;
					}
					if (item.kind == "file") {
						// blob 就是从剪切板获得的文件，可以进行上传或其他操作
						const blob = item.getAsFile();
						// console.log('获得blob', blob);
						if (blob.size === 0) {
							return;
						}
						const reader = new FileReader();
						const imgs = new Image();
						imgs.file = blob;

						// 这里可能是 多个文件，所以要写同步
						let num = 0;
						num = i + 1;
						// console.log('上传第' + (i + 1) + '次');
						// await this.load_file(imgs.file);


						// reader.onload = (function(aImg) {
						// 	return function(e) {
						// 		// console.log('获得粘贴的结果', e);
						// 		// console.log('获得粘贴的结果', e.target.result);
						// 		that.file_data = e.target.result;
						// 		that.file_url = e.target.result;
						// 	};
						// })(imgs);
						// reader.readAsDataURL(blob);	
						let o = {};
						o.id = i + 1;
						o.file = imgs.file;
						o.mode_name = '待划分';
						// this.list_sel.push(imgs.file);
						this.list_sel.push(o);
					}
				}
				// console.log('加载完成...');
				// this.up_method = "cut";	//截图上传
				if (this.list_sel.length > 1) {
					// console.log('加载多个完成...');
					this.show_one = false;
					// console.log(this.list_sel);
				} else {
					this.load_file_one(this.list_sel[0].file);

				}
			},

			load_file_one: async function(f) {
				// let f = this.list_sel[0];
				// console.log('获得文件', f);

				this.show_one = true;
				this.file_url = '';
				this.file_src = '';
				this.file_data = '';
				this.file_backdata = '';
				this.file_name = '';
				this.file_size = '';
				this.file_type = '';
				let res = '';

				res = await this.fun_blod_toString(f);
				//这个方法导致不能一次性传多个文件
				this.file_name = f.name;
				this.file_size = f.size;
				this.file_type = f.name.substring(f.name.indexOf('.') + 1);
				this.file_url = res;
				this.file_data = res;
				this.file_backdata = f;
				this.mode_name = '';
				// console.log('文件类型=' + this.file_type + ' 大小=' + this.file_size);
				if (!(/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(f.name.toLowerCase()))) {
					// console.log("只可以上传图片、pdf格式");
					this.file_url = '';
					this.show_lookimg = false;
				} else {
					this.show_lookimg = true;
				}
				this.check_file(this.file_url, this.file_src);

				// let temp_name = '',
				// 	ftype = '';
				// temp_name = JsonCheck(f.name);
				// let random_name = GetRandom();
				// temp_name = random_name + temp_name;
				// ftype = f.name.substring(f.name.indexOf('.') + 1);


				// 自动完成上传操作
				// this.fun_auto_up(f, temp_name, ftype, f.size);

			},
			fun_file_more_del: function(f) {
				for (let i = 0; i < this.list_sel.length; i++) {
					if (this.list_sel[i].name == f.name && this.list_sel[i].type == f.type) {
						this.list_sel.splice(i, 1);
						break;
					}
				}

				if (this.list_sel.length == 1) {
					this.load_file_one(this.list_sel[0]);
				}
			},
			fun_file_more_one: async function(f) {
				console.log('单传一个文件', f);
				this.element_loading = true;

				let name = '',
					size = '',
					type = '',
					o = {};

				let res = await this.fun_blod_toString(f.file);
				//这个方法导致不能一次性传多个文件
				name = f.file.name;

				let random_name = GetRandom();
				o.fname = random_name + JsonCheck(name);
				o.size = f.file.size;
				o.type = name.substring(name.indexOf('.') + 1);
				o.fdata = f.file;
				o.mode_name = f.mode_name;

				await this.fun_auto_up(o);

				this.refresh_data();
				this.element_loading = false;
			},
			fun_file_more_up: async function() {
				this.element_loading = true;

				let temp_list = [];
				for (let i = 0; i < this.list_sel.length; i++) {
					let t = '',
						o = {};
					t = await this.fun_blod_toString(this.list_sel[i].file);

					let name = '';
					name = this.list_sel[i].file.name;
					let random_name = GetRandom();
					o.fname = random_name + JsonCheck(name);
					o.size = this.list_sel[i].file.size;
					o.type = name.substring(name.indexOf('.') + 1);
					o.fdata = this.list_sel[i].file;
					o.mode_name = this.list_sel[i].mode_name;
					temp_list.push(o);
				}
				// console.log('转换后', temp_list);
				for (let i = 0; i < temp_list.length; i++) {
					await this.fun_auto_up(temp_list[i]);
				}

				this.refresh_data();
				this.element_loading = false;
			},
			fun_auto_up: async function(f) {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				let filebackdata = '';

				maxFileLength = f.size;
				this.blockSize = 1 * 1024 * 1024;
				filebackdata = f.fdata;
				// console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);
				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}
					console.log('上传长度=' + start + ' 至' + end);
					let temp_data = '';
					temp_data = filebackdata.slice(start, end); //文件切片
					// console.log('上传长度=', temp_data);
					// ////console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_auto_up_block(temp_data, f.fname);
						//console.log(res);
						if (res.status == 1) {
							// this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
							// 	" %";
							// console.log('文件=' + f.file.fname + ' 上传成功');
						} else {
							// console.log(' 上传失败', res);
						}
					} catch (error) {
						res = await this.fun_auto_up_block(temp_data, f.fname);
					}
					start = end;
					num++;
				}
				// console.log('文件=' + f.fname + ' 上传完成');

				var postdata = "";

				postdata =
					'{"action":"data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","f_name":"' +
					f.fname +
					'","f_type":"' +
					f.type +
					'","f_size":"' +
					f.size +
					'","f_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + f.fname +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","mode_type":"' +
					this.mode_type +
					'","mode_name":"' +
					f.mode_name +
					'"}';

				// ////console.log(postdata);
				postdata =
					'{"method":"File_NewSavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;

				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						this.$message({
							message: '上传成功',
							type: 'success'
						});

					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});
			},
			fun_auto_up_block: async function(temp_data, fname) {
				// ////console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}

				let temp_filedata = await this.fun_blod_toString(temp_data);
				// console.log('sheet_no=' + this.sheet_no + ' p1=' + this.p1 + ' p2=' + this.p2 + ' p3=' + this.p3);
				let that = this;
				var postdata = "";

				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					fname +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no + '","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// ////console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// ////console.log(res);

						resolve(res.data)
					})
				});

			},
			//单独修改划分///////////////////////
			fun_sel_file: function(item) {
				this.mode_name = item.mode_name;
				this.list_sel_id = item.id;
			},
			fun_upd_mode: function() {
				if (Number(this.row_id) == 0) {
					this.$message({
						message: '请选择要操作的附件!',
						type: 'warning'
					});
					return
				}

				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Method_EasyUpdate('upd_filemore', this.row_id, this.mode_name, '', '', '',
						this.sys_date)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log(res);

					if (res.data.status == '1') {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.refresh_data();
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			},
			///////////////////////////
			check_file: function(file_url, file_src) {
				// console.log(file_url.length);
				this.file_src = '';
				this.file_url = '';
				if (typeof(file_url) !== 'undefined' && file_url != '') {
					this.file_url = file_url;
					this.show_file = true;
				} else {
					this.show_file = false;
				}
				if (typeof(file_src) !== 'undefined' && file_src != '') {
					this.file_src = file_src;
				}
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			chang_style: function() {
				let that = this;
				this.$nextTick(function() {
					that.screenWidth = $(window).width();
					that.screenHeight = $(window).height(); //当前浏览器窗口的 宽高
					var scrolltop = $(document).scrollTop(); //获取当前窗口距离页面顶部高度
					// console.log('屏宽='+this.screenWidth+' 屏高='+this.screenHeight);

				});
			},
			showpop: function() {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop-tan-bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop-tan-bg").fadeIn("3000");
				$(".pop-tan-content").fadeIn("3000");
				this.chang_style();

			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			load_data: function(res) {
				// console.log('文件列表加载', res);

				// 清理缓存
				this.row_id = ''; //对应文件数据表的ID
				this.sel_action = '';
				this.file_action = '';

				this.mode_type = res.row_id; //对应数据项目ID
				if (Number(res.row_id) == 0) {
					this.$message({
						message: '请先点击一条数据,才能查看相应附件!',
						type: 'warning'
					});
					return;
				}
				this.showpop();
				this.title = res.title;
				this.sheet_no = res.sheet_no;

				let temp_from = '_m';
				switch (res.sel_from) {
					case 'm':
						this.sel_from = '主单';
						temp_from = '_m';
						break;
					case 'd':
						this.sel_from = '明细';
						temp_from = '_d';
						break;
					case 't':
						this.sel_from = '拓展明细';
						temp_from = '_t';
						break;
					default:
						this.sel_from = '请选择范围!';
						break;
				}

				this.sel_action = 'exp_sel_all_file' + temp_from; //查询方法必须区分
				this.file_action = res.file_action + temp_from;


				this.p1 = res.p1;
				let date = new Date();
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				// var h = date.getHours();
				// h = h < 10 ? ('0' + h) : h;
				// var minute = date.getMinutes();
				// minute = minute < 10 ? ('0' + minute) : minute;
				// this.file_time = y + '' + m + '' + d + '' + h + '' + m;
				this.p2 = y + '' + m + '' + d;
				this.p3 = res.p2;

				this.fileup = res.file_up;
				this.filelook = res.file_look;
				this.filedel = res.file_del;

				this.sheet_flag = res.sheet_flag;
				if (this.sheet_flag == '已提交') {
					this.show_btn = false;
				} else {
					this.show_btn = true;
				}

				// 判断是否预加载 显示图片
				this.check_file(res.file_url, res.file_src);
				// 加载集合图片
				this.refresh_data();

			},
			refresh_data: async function() {

				if (this.filelook != '1') {
					this.$message({
						message: '没有权限查看附件集!',
						type: 'warning'
					});
					return;
				}

				this.element_loading = true;
				this.fun_clear();
				this.list_file = [];

				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Sel_page_and_length(this.sel_action, 1, 100, this.sheet_no, this.mode_type)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res[0]);
					if (typeof(res[0]) !== 'undefined' && res[0].length > 0) {
						let t = res[0];

						for (let i = 0; i < t.length; i++) {
							let o = {};

							o = t[i];
							o.row_num = i + 1;
							this.list_file.push(o);
						}

						// console.log(this.list_file);
					} else {
						this.$message({
							message: '未查询到数据',
							type: 'warning'
						});
					}
				});
			},
			sel_row: function(item) {
				// console.log('选择', item);
				this.row_id = item.id;
				this.sys_date = item.sys_date;
				this.sheet_no = item.sheet_no;
				this.mode_name = item.m_name;
				this.mode_type = item.m_id;

				let tt = BackSpecial(item.f_url);
				tt = tt.substring(tt.lastIndexOf('/') + 1);
				this.file_name = tt;
				this.file_url = item.f_url;

				this.file_src = item.f_src;
				this.file_up = '';
				// console.log(this.file_url);
				// console.log(this.file_src);
				this.setCurrentRowJsonOld('f', item.row_num);
			},
			fun_clear: function() {
				// this.f_name = '';
				this.row_id = '';

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				this.file_size = 0;
				this.file_type = '';

				this.file_url = '';
				this.file_src = '';

			},
			setCurrentRowJsonOld: function(key, id) {
				// console.log(this.list_file );
				for (var i = 0; i < this.list_file.length; i++) {
					// console.log(this.data_tab[i][1]);
					if (this.list_file[i].row_num == id) {
						document.getElementById(key + id).style.background = '#92a4f3';
					} else {
						if (this.list_file[i].row_num % 2 == 0) {
							document.getElementById(key + this.list_file[i].row_num).style.background = '#fff';
						} else {
							document.getElementById(key + this.list_file[i].row_num).style.background = '#f5f5f5';
						}
					}
				}
			},
			//附件操作 start //////////////////////////////////////
			//附件操作 start //////////////////////////////////////
			pre_look_file: function(f_url) {
				this.file_url = "";
				this.file_name = "";

				this.file_url = BackSpecial(f_url);
				// console.log('点击预览附件' + this.file_url);

				let tt = '';
				tt = this.file_url;
				tt = tt.substring(tt.lastIndexOf('/') + 1);
				this.file_name = tt;
				// 可以通过判断附件数量大于1时,通过小弹出进行编辑操作

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('pre_loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("pre_downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			// 点击上传附件
			pre_sel_file: function() {
				
				
				
				this.file_data = "";
				this.file_backdata = "";

				let fileobj = document.getElementById(this.fileId);
				// document.selection.clear(); //清空附件选择 测试无效！
				fileobj.value = '';
				// fileobj.outerHTML = fileobj.outerHTML; //重新初始化了fileobj的html
				fileobj.click();
			},
			getFilePath: function() {
				let tmpFile = document.getElementById(this.fileId);
				// //console.log('点击选择结果');
				// //console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 20000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// //console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.sel_filename = '';
					this.sel_filename = name;
					this.file_name = JsonCheck(name);
					this.show_file = true; //显示 范围

					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// //console.log(tmpFile);   //连标签原样输出了
					// //console.log(tmpFile.value);   //图片路径


					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
						// console.log(that.file_data);
					}
					// //console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			pre_del_file: function() {
				if (this.sheet_flag == '已提交') {
					this.$message({
						message: '当前单号:' + this.sheet_no + ' 已经提交,不能删除附件!',
						type: 'warning'
					});
					return;
				}

				this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.pre_del_ok();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			pre_del_ok: function() {
				//console.log('点击删除附件');

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";

				postdata =
					'{"action":"' + this.file_action + '_del","user_no":"' +
					GetShort("userno") +
					'","sheet_no":"' +
					this.sheet_no +
					'","rowid":"' +
					this.row_id +
					'","mode_type":"' +
					this.mode_type +
					'"}';

				// ////console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// ////console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});

					this.file_up = res.data.msg;

					for (let i = 0; i < this.list_file.length; i++) {
						if (this.list_file[i].id == this.row_id) {
							this.list_file.splice(i, 1);
						}
					}

				});

			},
			fun_del_file_three: function() {

				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					//console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

						this.file_name = '';
						this.file_url = '';
						this.file_src = '';
						this.file_data = '';
						this.file_backdata = '';


					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			pre_up_file: async function() {
				// console.log('当前附件数量='+this.list_file.length)
				if(this.sel_from == '明细' && this.list_file.length>=1){
					this.$message({
						message: '明细数据只可以上传一条附件!',
						type: 'warning'
					});
					return;
				}
				
				let temp_name = '';
				temp_name = JsonCheck(this.file_name);
				let random_name = GetRandom();
				this.file_name = random_name + temp_name;

				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				//console.log('base64文件大小=' + this.file_data.length)
				// 一块文件的大小
				console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0) {
					// console.log('文件上传');
					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				this.file_size = maxFileLength;
				// console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// ////console.log('上传长度=' + temp_data.size);
					// ////console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						////console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// ////console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// ////console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);
				// 这里保存文件数据。因为是切片追加模式，而且不写路径。所以row_id和sheet_no 不用传

				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					this.file_name +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no + '","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// ////console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// ////console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// ////console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// ////console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				////console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";

				postdata =
					'{"action":"data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","f_name":"' +
					this.file_name +
					'","f_type":"' +
					this.file_type +
					'","f_size":"' +
					this.file_size +
					'","f_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","mode_type":"' +
					this.mode_type +
					'","mode_name":"' +
					this.mode_name +
					'"}';

				// ////console.log(postdata);
				postdata =
					'{"method":"File_NewSavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;

				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.refresh_data();
						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			}

		}
	};
</script>


<style scoped>
	.pop-tan {
		position: fixed;
		left: 0;
		top: 100px;
		width: 100vw;
		height: auto;
		/* border: 1px solid #ccc; */
		z-index: 30;
		display: flex;
		justify-content: center;
		align-items: stretch;
	}

	.pop-tan-bg {
		width: 100vw;
		background: #000000;
		opacity: 0.5;
		position: fixed;
		top: 0;
		left: 0;
		height: 100vh;
		display: none;
		z-index: 99;
	}

	.pop-tan-content {
		height: auto;
		/* background: #faf5f5; */
		background-color: rgb(195, 219, 250);
		position: fixed;
		border-radius: 3px;
		display: none;
		z-index: 999;
		/* padding: 5px; */
		overflow: hidden;

		display: inline-block;
		min-width: 960px;
		width: 1320px;

		max-height: 80vh;
		max-width: 90%;
		overflow: auto;
		box-shadow: 0 0 5px 5px #04567f;
	}

	.pop-tan_children {
		display: inline-flex;
		flex-direction: column;
		background-color: aliceblue;
		background: rgb(195, 219, 250);
		padding: 20px;
		border-radius: 5px;
	}

	.pop-tan-head-close {
		color: #b4b4b4;
		cursor: pointer;
		font-weight: normal;
		text-align: right;
		display: inline-flex;
		justify-content: flex-end;
		margin-top: -20px;
		margin-right: -20px;

		min-width: 960px;
		width: 1280px;

	}




	.pop-tan-head-body {
		display: inline-flex;
		flex-direction: column;
		min-width: 200px;
		min-height: 200px;

		/* max-width: 80vw; */
		/* overflow: auto; */
	}

	.content-row {
		display: flex;
		justify-content: flex-start;
	}

	.file-right {
		display: flex;
		flex-direction: column;

		margin-left: 6px;
		padding: 2px;
	}

	.file-up {
		display: flex;
		min-height: 200px;
		min-width: 200px;
		background-color: #ffffff;

		font-size: 120px;
		justify-content: center;
		align-items: center;
		color: #eeeeee;
		border-radius: 8px;
	}

	.file-up img {
		max-height: 200px;
		width: auto;
	}

	.file-other {
		font-size: 24px;
		font-weight: bold;
		color: #000;
	}

	.file-txt {
		margin-top: 6px;
		font-weight: bold;
		font-size: 12px;
		display: flex;
		justify-content: center;
		color: #ff0000;
	}

	/*  */
	.f-body {
		display: flex;
		width: 320px;

		background-color: #fff;
		border-radius: 5px;


		flex-direction: column;
		border: 1px solid #fff;
	}

	.f-sel {
		display: flex;
		width: 100%;
		justify-content: flex-start;
		align-items: center;
		line-height: 28px;
		height: 28px;
		padding: 2px;
	}

	.f-title {
		width: 188px;
		max-width: 188px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 28px;
		height: 28px;
		word-break: keep-all;
		text-align: left;
		cursor: pointer;
	}

	.f-class {
		width: 68px;
		max-width: 168px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 28px;
		height: 28px;
		word-break: keep-all;
		text-align: center;
		cursor: pointer;
	}

	.f-title:hover {
		background-color: #eeeeee;
		border-radius: 5px;
	}

	.f-bottom {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		line-height: 28px;
		height: 28px;
		padding: 2px;
	}
</style>